import { styled } from "theme/default/styled";

export const SCreateFormList = styled.div`
  padding: 0 20px;
`;
